<div class="popover-header">
  <h3> {{ data?.header }} </h3>
  <mat-icon (click)="dialogRef.close()" class="cursor">close</mat-icon>
</div>

<div class="make-responsive-dtc-list">
  <div *ngFor="let item of data?.chipData">
    <span class="chip-link" (click)="item?.navigate ? navigateTo(item?.id, 'dtcId') : ''"
      *ngIf="data?.id === 'dtcDetails'">
      <a class="hyper-link">{{ item?.dtc }}</a>
    </span>

    <span class="chip-link" *ngIf="data?.id === 'engineModel' || data?.id === 'emissionNorm'">
      <a>{{ item }}</a>
    </span>
  </div>
</div>